<span class="poll">
  <span class="body" *ngIf="poll != null">
    <div class="question">
      {{ poll.question }}
    </div>
    <div class="options" *ngIf="poll.can_vote">
      <div class="option" *ngFor="let option of poll.options; let i = index;" (click)="castVote(i+1)">
        <div class="text">{{ option.name }}</div>
      </div>
    </div>
    <div class="results" *ngIf="!poll.can_vote">
      <div class="result" *ngFor="let result of poll.options;let i = index;">
        <div class="bar" (click)="showLikeList(i+1,result.name)">
          <div class="left">
              {{result.name}}
          </div>
          <div class="right">
              {{ result.percentage }}% ({{ result.votes }})
          </div>
          <div class="percentage" [ngStyle]="{'width': result.percentage + '%'}"></div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px; line-height: 0px;">
      <span class="indicator">POLL</span>
      <span class="totalVotes">
        Total Votes: {{ poll.total_votes }}
      </span>  
    </div>
  </span>
</span>